import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Opcoes {
  id: number;
  title: string;
  sectionId: number;
  sectionNumber: number;
  desabilitado: boolean;
  rota: string;
  // Fora do menu lateral; a rota continua acessível.
  oculto?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EtapasDeEdicaoService {
  public opcoes = new BehaviorSubject<Opcoes[]>([]);
  public opcaoAtual = new BehaviorSubject<number>(1);

  constructor() {
    this.opcoes.next([
      {
        id: 1,
        title: 'Diagnóstico das matrículas',
        sectionId: 1,
        sectionNumber: 1,
        desabilitado: false,
        rota: '/acesso-oferta-educacional/diagnostico-matricula',
      },
      {
        id: 2,
        title: 'Projeção da oferta de matrículas',
        sectionId: 1,
        sectionNumber: 2,
        desabilitado: false,
        rota: '/acesso-oferta-educacional/projecao-da-oferta',
      },
      {
        id: 3,
        title: 'Resultado da projeção de matrículas',
        sectionId: 1,
        sectionNumber: 3,
        desabilitado: false,
        rota: '/acesso-oferta-educacional/resultado-projecao',
      },
      {
        id: 4,
        title: 'Divisão da responsabilidade pela oferta',
        sectionId: 1,
        sectionNumber: 4,
        desabilitado: true,
        rota: '',
      },
      {
        id: 5,
        title: 'Número de dias letivos',
        sectionId: 2,
        sectionNumber: 1,
        desabilitado: false,
        rota: '/condicao-qualidade/numero-de-dias-letivos',
      },
      {
        id: 6,
        title: 'Carga horária de ensino',
        sectionId: 2,
        sectionNumber: 2,
        desabilitado: false,
        rota: '/condicao-qualidade/carga-horaria-de-ensino',
      },
      {
        id: 16,
        title: 'Tempo integral',
        sectionId: 2,
        sectionNumber: 3,
        desabilitado: true,
        rota: '',
      },
      {
        id: 7,
        title: 'Tamanho das turmas',
        sectionId: 2,
        sectionNumber: 4,
        desabilitado: false,
        rota: '/condicao-qualidade/tamanho-das-turmas',
      },
      {
        id: 8,
        title: 'Docentes: formação e remuneração',
        sectionId: 2,
        sectionNumber: 5,
        desabilitado: false,
        rota: '/condicao-qualidade/docente-formacao-remuneracao',
      },
      {
        id: 24,
        title: 'Auxiliares: Formação e remuneração',
        sectionId: 2,
        sectionNumber: 6,
        desabilitado: true,
        rota: '',
      },
      {
        id: 9,
        title: 'Docentes: quantidade por etapa/modalidade',
        sectionId: 2,
        sectionNumber: 7,
        desabilitado: false,
        rota: '/condicao-qualidade/quantidade-docente-etapa',
      },
      {
        id: 10,
        title: 'Funcionários: quadro e remuneração',
        sectionId: 2,
        sectionNumber: 8,
        desabilitado: false,
        rota: '/condicao-qualidade/quadro-funcionarios-remuneracao',
      },
      {
        id: 11,
        title: 'Funcionários: quantidade por função',
        sectionId: 2,
        sectionNumber: 9,
        desabilitado: false,
        rota: '/condicao-qualidade/numero-funcionarios-funcao',
      },
      {
        id: 23,
        title: 'Adicional de remuneração',
        sectionId: 2,
        sectionNumber: 10,
        desabilitado: false,
        rota: '/condicao-qualidade/docente-adicional-remuneracao',
      },
      {
        id: 14,
        title: 'Serviços, infraestrutura e recursos',
        sectionId: 2,
        sectionNumber: 11,
        desabilitado: false,
        rota: '/condicao-qualidade/servicos-infraestrutura-recursos',
      },
      {
        id: 15,
        title: 'Alimentação escolar',
        sectionId: 2,
        sectionNumber: 12,
        desabilitado: false,
        rota: '/condicao-qualidade/alimentacao-escolar',
      },
      {
        id: 25,
        title: 'Adicional para modalidades e contextos',
        sectionId: 2,
        sectionNumber: 13,
        desabilitado: false,
        rota: '/condicao-qualidade/fator-ponderacao',
      },
      {
        id: 22,
        title: 'Direitos e obrigações trabalhistas',
        sectionId: 2,
        sectionNumber: 14,
        desabilitado: false,
        rota: '/condicao-qualidade/direitos-obrigacoes-trabalhistas',
      },
      {
        id: 12,
        title: 'Salas de aula: diagnóstico e projeção',
        sectionId: 3,
        sectionNumber: 1,
        desabilitado: true,
        rota: '',
        oculto: true, // #1472: seção "Infraestrutura escolar" fora do menu
      },
      {
        id: 13,
        title: 'Espaços escolares: reforma e adequação',
        sectionId: 3,
        sectionNumber: 2,
        desabilitado: false,
        rota: '/infraestrutura-escolar/espacos-escolares-reforma-adequacao',
        oculto: true, // #1472: seção "Infraestrutura escolar" fora do menu
      },
    ]);
  }

  getOpcoes(): Observable<Opcoes[]> {
    return this.opcoes.asObservable();
  }

  desabilitarOpcao(id: number): void {
    this.opcoes.next(this.opcoes.getValue().map((opcao) => ({ ...opcao, desabilitado: opcao.id === id ? true : opcao.desabilitado })))
  }

  habilitarOpcao(id: number): void {
    this.opcoes.next(this.opcoes.getValue().map((opcao) => ({ ...opcao, desabilitado: opcao.id !== id ? opcao.desabilitado : false })));
  }

  setOpcaoAtual(opcao: number): void {
    this.opcaoAtual.next(opcao);
  }

  getOpcaoAtual(): Observable<number> {
    return this.opcaoAtual.asObservable();
  }
}
